/* Moellia 2.6 — interactions légères (carrousels, avant/après, prix du bouton, libellés des filtres, menu, icônes du pied de page) */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Apparition douce des éléments au défilement (neutralisée en CSS : tout est visible immédiatement)
  const initReveal = (root = document) => {
    const items = root.querySelectorAll('[data-mo-reveal]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    items.forEach((el) => io.observe(el));
  };

  // Flèches des carrousels produits
  const initRails = (root = document) => {
    root.querySelectorAll('[data-mo-rail]').forEach((rail) => {
      if (rail.dataset.moReady) return;
      rail.dataset.moReady = '1';
      const track = rail.querySelector('[data-mo-track]');
      const step = () => {
        const item = track.querySelector('.mo-rail__item');
        return item ? item.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      };
      rail.querySelector('[data-mo-prev]')?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      rail.querySelector('[data-mo-next]')?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    });
  };

  // Curseur avant / après : les étiquettes disparaissent quand leur côté de la photo n'est plus visible
  const initCompare = (root = document) => {
    root.querySelectorAll('[data-mo-compare]').forEach((box) => {
      if (box.dataset.moReady) return;
      box.dataset.moReady = '1';
      const range = box.querySelector('input[type="range"]');
      const tagBefore = box.querySelector('.mo-compare__tag--before');
      const tagAfter = box.querySelector('.mo-compare__tag--after');
      [tagBefore, tagAfter].forEach((t) => {
        if (t) t.style.transition = 'opacity 0.25s ease';
      });
      const set = (v) => {
        box.style.setProperty('--pos', `${v}%`);
        const n = Number(v);
        if (tagBefore) tagBefore.style.opacity = n < 16 ? '0' : '1';
        if (tagAfter) tagAfter.style.opacity = n > 84 ? '0' : '1';
      };
      range.addEventListener('input', () => set(range.value));
      set(range.value);
    });
  };

  // Prix affiché dans le bouton « Ajouter au panier » de la fiche produit (suit le changement de variante)
  // Les boutons des cartes (« Choisir » / quick-add), des recommandations et des fenêtres modales sont exclus.
  const initAtcPrice = () => {
    const main = document.querySelector('main');
    if (!main || !/^product/.test(main.dataset.template || '')) return;
    const priceEl = main.querySelector('.product-details product-price') || main.querySelector('product-price');
    if (!priceEl) return;
    const EXCLUDED = 'quick-add-component, .quick-add, .quick-add__button, product-card, .product-card, product-recommendations, dialog, .quick-add-modal';
    const eligible = (btn) => !btn.closest(EXCLUDED);
    const read = () => {
      const el = [...priceEl.querySelectorAll('.price-item--sale, .price')].find(
        (e) => e.offsetParent !== null && e.textContent.trim()
      );
      return el ? el.textContent.trim().replace(/\s*TTC\s*$/i, '') : '';
    };
    const paint = () => {
      const price = read();
      document.querySelectorAll('.add-to-cart-button').forEach((btn) => {
        const host = btn.querySelector('.add-to-cart-text__content') || btn.querySelector('.add-to-cart-text');
        if (!host) return;
        let tag = host.querySelector('.mo-atc-price');
        if (!eligible(btn) || btn.disabled || !price) {
          tag?.remove();
          return;
        }
        if (!tag) {
          tag = document.createElement('span');
          tag.className = 'mo-atc-price';
          host.appendChild(tag);
        }
        if (tag.textContent !== price) tag.textContent = price;
      });
    };
    paint();
    let timer;
    new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(paint, 60);
    }).observe(main, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });
  };

  // Libellés des filtres Shopify restés en anglais (Availability, Price, In stock, Out of stock…)
  const FILTER_FR = {
    'availability': 'Disponibilité',
    'price': 'Prix',
    'in stock': 'En stock',
    'out of stock': 'Épuisé',
    'product type': 'Type de produit',
    'vendor': 'Marque',
    'color': 'Couleur',
    'size': 'Taille',
  };
  const translateFilters = () => {
    document.querySelectorAll('.facets, facets-form-component, [class*="facets"], .pills__pill').forEach((scope) => {
      const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const text = node.nodeValue.trim();
        if (!text) continue;
        const exact = FILTER_FR[text.toLowerCase()];
        if (exact) {
          node.nodeValue = node.nodeValue.replace(text, exact);
        } else if (/(Availability|In stock|Out of stock)/i.test(text)) {
          node.nodeValue = node.nodeValue.replace(/(Availability|In stock|Out of stock)/gi, (m) => FILTER_FR[m.toLowerCase()]);
        }
      }
    });
  };
  const initFilterLabels = () => {
    translateFilters();
    let timer;
    const main = document.querySelector('main');
    if (!main) return;
    new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(translateFilters, 40);
    }).observe(main, { subtree: true, childList: true });
  };

  // Menu principal : page courante soulignée + ouverture fiable du menu déroulant au survol
  const initMenu = () => {
    const norm = (p) => (p.replace(/\/+$/, '') || '/');
    const path = norm(location.pathname);
    const links = [...document.querySelectorAll('header-component .menu-list__link[href]')];
    let current = links.find((a) => norm(new URL(a.href, location.origin).pathname) === path);
    if (!current && /^\/(collections|products)\//.test(path)) {
      current = links.find((a) => norm(new URL(a.href, location.origin).pathname) === '/collections/all');
    }
    links.forEach((a) => a.classList.toggle('is-current-page', a === current));

    document.querySelectorAll('header-component .menu-list__list-item').forEach((li) => {
      const a = li.querySelector('.menu-list__link[aria-haspopup]');
      if (!a || li.dataset.moHover) return;
      li.dataset.moHover = '1';
      li.addEventListener('pointermove', (e) => {
        if (e.pointerType === 'touch') return;
        if (a.getAttribute('aria-expanded') !== 'true') {
          li.dispatchEvent(new PointerEvent('pointerenter', { pointerType: 'mouse', bubbles: true }));
        }
      });
    });
  };

  // Pied de page : icônes devant l'adresse, le téléphone et l'e-mail (les textes ne sont pas modifiés)
  const FOOTER_ICONS = {
    pin: '<path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.4"/>',
    phone: '<path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z"/>',
    mail: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3.5 7l8.5 6 8.5-6"/>',
  };
  const initFooterIcons = () => {
    document.querySelectorAll('.shopify-section-group-footer-group .text-block p').forEach((p) => {
      if (p.dataset.moIcon) return;
      const t = p.textContent.trim();
      let kind = '';
      if (/Louisiana|États-Unis|Etats-Unis/i.test(t)) kind = 'pin';
      else if (/^t[ée]l[ée]?phone\s*:/i.test(t)) kind = 'phone';
      else if (/^e-?mail\s*:/i.test(t)) kind = 'mail';
      if (!kind) return;
      p.dataset.moIcon = kind;
      p.style.display = 'flex';
      p.style.alignItems = 'flex-start';
      p.style.gap = '12px';
      const icon = document.createElement('span');
      icon.setAttribute('aria-hidden', 'true');
      icon.style.cssText = 'flex:0 0 auto;display:inline-flex;margin-top:0.2em;color:#c4a67e';
      icon.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' + FOOTER_ICONS[kind] + '</svg>';
      const text = document.createElement('span');
      while (p.firstChild) text.appendChild(p.firstChild);
      p.appendChild(icon);
      p.appendChild(text);
    });
  };

  const init = (root) => {
    initReveal(root);
    initRails(root);
    initCompare(root);
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.documentElement.classList.add('mo-js');
    init(document);
    initAtcPrice();
    initFilterLabels();
    initMenu();
    initFooterIcons();
  });

  // Rechargement des sections dans l'éditeur de thème
  document.addEventListener('shopify:section:load', (e) => {
    init(e.target);
    initFooterIcons();
  });
})();
